module.exports = __webpack_public_path__ + "static/media/charitable.dfdba2c1.svg";